import { prepareAutoBatched } from "@reduxjs/toolkit";
import envSettings from "../../services/system/envSettings";
import { baseApi } from "./baseApi";
import { Log } from "../../models/logging/log";

export const infraApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    addLogData: builder.mutation<void, Log>({
      query(trackingData) {
        return {
          url: `${envSettings.LOG_API_URL}/${envSettings.LOG_PREF}`,
          method: "POST",
          body: { logs: [trackingData] },
          prepare: prepareAutoBatched<Log>(),
        };
      },
    }),
    testToken: builder.query<void, void>({
      query: () => `${envSettings.UTILS_API_URL}/non-shall-pass`,
    }),
  }),
});
export const { useAddLogDataMutation, useLazyTestTokenQuery } = infraApi;
